import {
  View,
  Text,
  Image,
  TouchableOpacity,
  StyleSheet,
  ScrollView,
  Linking,
} from "react-native";
import React from "react";
import AthelasLogo from "../../assets/logo.png";
import DoctorFlatDesignPNG from "./assets/doctors-flat-design.png";
import { trackEvent } from "../../utils/tracking";

type PropsType = {
  navigation: any;
};

const SUPPORT_EMAIL = "help@getathelas.com";

export function LoginAttempt(props: PropsType) {
  const onContactSupportClicked = () => {
    trackEvent("click", "program_ended_contact_support");
    Linking.openURL(`mailto:${SUPPORT_EMAIL}`);
  };

  return (
    <View style={styles.screen}>
      <ScrollView
        contentContainerStyle={styles.scrollContent}
        showsVerticalScrollIndicator={false}
      >
        <Image
          source={AthelasLogo}
          style={styles.athelasLogo}
          resizeMode="contain"
        />
        <Image
          source={DoctorFlatDesignPNG}
          style={styles.highlightImage}
          resizeMode="contain"
        />

        <View style={styles.jumbotron}>
          <Text style={styles.header}>This program has ended</Text>
          <Text style={styles.subtitle}>
            The Athelas At-Home Monitoring program has been discontinued, and
            this app is no longer available.
          </Text>
        </View>

        <Text style={styles.bodyText}>
          You can no longer sign in to view your at-home device data or health
          trends here. If you have questions about your care, please reach out
          to your care team or your healthcare provider.
        </Text>

        <Text style={styles.bodyText}>
          For questions about the program or your records, contact us at{" "}
          <Text style={styles.link} onPress={onContactSupportClicked}>
            {SUPPORT_EMAIL}
          </Text>
          .
        </Text>

        <TouchableOpacity
          onPress={onContactSupportClicked}
          style={styles.buttonWrapper}
        >
          <View style={styles.contactButtonContainer}>
            <Text style={styles.contactButtonText}>CONTACT SUPPORT</Text>
          </View>
        </TouchableOpacity>
      </ScrollView>
    </View>
  );
}

const styles = StyleSheet.create({
  screen: {
    flex: 1,
    backgroundColor: "white",
  },
  scrollContent: {
    flexGrow: 1,
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: 24,
    paddingTop: 64,
    paddingBottom: 64,
  },
  contactButtonContainer: {
    backgroundColor: "#FE5E85",
    padding: 12,
    paddingLeft: 48,
    paddingRight: 48,
    borderRadius: 16,
  },
  contactButtonText: {
    color: "white",
    fontWeight: "bold",
    textAlign: "center",
  },
  buttonWrapper: {
    marginTop: 24,
  },
  subtitle: { fontSize: 16, color: "#565F76", textAlign: "center" },
  bodyText: {
    fontSize: 16,
    color: "#565F76",
    textAlign: "center",
    maxWidth: 300,
    marginTop: 16,
    lineHeight: 22,
  },
  link: {
    color: "#FE5E85",
    fontWeight: "bold",
  },
  header: {
    fontWeight: "bold",
    fontSize: 20,
    marginBottom: 8,
    color: "#565F76",
    textAlign: "center",
  },
  highlightImage: {
    width: 240,
    height: 180,
    marginTop: -20,
    marginLeft: "auto",
    marginRight: "auto",
  },
  jumbotron: {
    padding: 16,
    borderRadius: 16,
    backgroundColor: "#EAEAEA",
    marginTop: 24,
    maxWidth: 300,
  },
  athelasLogo: {
    width: 160,
    height: 100,
    marginLeft: "auto",
    marginRight: "auto",
  },
});
